// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_564b8d13","outerContainer":"deb93621","secondaryToolbar":"_151ea18a","doorHangerRight":"_2ca939f0","toolbarContainer":"_99f6fbe5","toolbarViewerMiddle":"_32bcedbc","progressBar":"ad4ab07a","back-to-application":"_1351ac14","root":"_9df2b425","content":"f5b673c4","details":"_91e4201d","detailsEmpty":"_123cbf14","title":"cdc18b1e","titleDanger":"_8c5dfb7c","subtitle":"_42e6763a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoTest/Components/ResultsCard/styles.styl
// module id = 5174
// module chunks = 39